import { supabase } from './supabaseClient';

/**
 * SupabaseからAI採点クレジット残数を取得
 */
export async function fetchAICredits(familyId) {
  if (!familyId) return 0;
  try {
    const { data, error } = await supabase
      .from('families')
      .select('ai_score_credits')
      .eq('id', familyId)
      .single();
    if (error) return 0;
    return data?.ai_score_credits || 0;
  } catch {
    return 0;
  }
}

/**
 * クレジットを1消費してSupabaseに保存。新しい残数を返す。
 */
export async function consumeAICredit(familyId, currentCredits) {
  if (!familyId || currentCredits <= 0) return currentCredits;
  const newCount = Math.max(0, currentCredits - 1);
  try {
    await supabase
      .from('families')
      .update({ ai_score_credits: newCount })
      .eq('id', familyId);
  } catch (e) {
    console.warn('クレジット消費エラー:', e);
  }
  return newCount;
}
